/**
 * 联络页
 */
export default function ContactPage() {
  return (
    <div className="min-h-full flex items-center justify-center p-8">
      <p className="text-lg text-default-600">联络尚未开发！</p>
    </div>
  );
}
